import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGallery, usePage } from 'app/hooks';
import { useGalleryService } from 'app/hooks/useGalleryService';
import { searchPreferencesActions } from 'app/actions';
import { galleryResultsAvailable } from 'app/actions/galleryActions';
import prepareGalleryResults from 'app/support/prepareGalleryResults';
import { useSearchPathBuilder } from '@unisporkal/search-url-builder';

export default () => {
  const dispatch = useDispatch();
  const gallery = useGallery();
  const page = usePage();
  const galleryService = useGalleryService();
  const searchPathBuilder = useSearchPathBuilder();
  const MAX_ASSETS = 100;

  const prepareRecentlyViewed = async () => {
    const recentlyViewedData =
      JSON.parse(window.localStorage.getItem('search.assetsViewedData')) || [];
    const assets = recentlyViewedData
      .slice(0, MAX_ASSETS)
      .map((asset) => asset.id)
      .join(',');
    if (assets.length === 0) {
      return;
    }

    const path = `${searchPathBuilder.recentlyViewedPath(assets)}`;
    const { searchPreferences, ...recentlyViewedSearchData } =
      await galleryService.getSearch(path);

    delete recentlyViewedSearchData.query.params.phrase;
    const galleryResults = prepareGalleryResults(recentlyViewedSearchData);

    dispatch(galleryResultsAvailable(galleryResults));
    dispatch(
      searchPreferencesActions.searchPreferencesAvailable(searchPreferences)
    );
  };

  useEffect(() => {
    if (gallery.isRecentlyViewedImages()) {
      prepareRecentlyViewed();
    }
  }, [page.status]);
};
